package com.ragnorak.clanybackoffice.ui.components

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ExitToApp
import androidx.compose.material.icons.filled.AccountCircle
import androidx.compose.material.icons.filled.CreditCard
import androidx.compose.material.icons.filled.DataObject
import androidx.compose.material.icons.filled.Group
import androidx.compose.material.icons.filled.Home
import androidx.compose.material.icons.filled.Inventory
import androidx.compose.material.icons.filled.Mail
import androidx.compose.material.icons.filled.Notifications
import androidx.compose.material.icons.filled.Person
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material.icons.filled.Webhook
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.ragnorak.clanybackoffice.Route

private val navColors
    @Composable get() = NavigationRailItemDefaults.colors(
        selectedIconColor = MaterialTheme.colorScheme.primary,
        selectedTextColor = MaterialTheme.colorScheme.primary,
        indicatorColor = MaterialTheme.colorScheme.primaryContainer
    )

@Composable
fun Sidebar(
    currentRoute: Route,
    onNavigate: (Route) -> Unit,
    onLogout: () -> Unit
) {
    NavigationRail(
        containerColor = MaterialTheme.colorScheme.surface,
        contentColor = MaterialTheme.colorScheme.onSurface,
        header = {
            Text(
                "Clany",
                style = MaterialTheme.typography.titleLarge,
                color = MaterialTheme.colorScheme.primary,
                fontWeight = FontWeight.Bold,
                modifier = Modifier.padding(vertical = 24.dp)
            )
        }
    ) {
        Column(
            modifier = Modifier.weight(1f).verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            NavigationRailItem(
                selected = currentRoute is Route.Dashboard,
                onClick = { onNavigate(Route.Dashboard) },
                icon = { Icon(Icons.Default.Home, contentDescription = "Dashboard", modifier = Modifier.size(24.dp)) },
                label = { Text("Dashboard") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Users,
                onClick = { onNavigate(Route.Users) },
                icon = { Icon(Icons.Default.Person, contentDescription = "Users", modifier = Modifier.size(24.dp)) },
                label = { Text("Users") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Accounts,
                onClick = { onNavigate(Route.Accounts) },
                icon = { Icon(Icons.Default.AccountCircle, contentDescription = "Accounts", modifier = Modifier.size(24.dp)) },
                label = { Text("Accounts") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Members,
                onClick = { onNavigate(Route.Members) },
                icon = { Icon(Icons.Default.Group, contentDescription = "Members", modifier = Modifier.size(24.dp)) },
                label = { Text("Members") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Subscriptions,
                onClick = { onNavigate(Route.Subscriptions) },
                icon = { Icon(Icons.Default.CreditCard, contentDescription = "Subscriptions", modifier = Modifier.size(24.dp)) },
                label = { Text("Subs") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.SubscriptionPlans,
                onClick = { onNavigate(Route.SubscriptionPlans) },
                icon = { Icon(Icons.Default.Inventory, contentDescription = "Plans", modifier = Modifier.size(24.dp)) },
                label = { Text("Plans") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Metadata,
                onClick = { onNavigate(Route.Metadata) },
                icon = { Icon(Icons.Default.DataObject, contentDescription = "Metadata", modifier = Modifier.size(24.dp)) },
                label = { Text("Metadata") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.WebhookEvents,
                onClick = { onNavigate(Route.WebhookEvents) },
                icon = { Icon(Icons.Default.Webhook, contentDescription = "Webhooks", modifier = Modifier.size(24.dp)) },
                label = { Text("Webhooks") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Invitations,
                onClick = { onNavigate(Route.Invitations) },
                icon = { Icon(Icons.Default.Mail, contentDescription = "Invitations", modifier = Modifier.size(24.dp)) },
                label = { Text("Invites") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Notifications,
                onClick = { onNavigate(Route.Notifications) },
                icon = { Icon(Icons.Default.Notifications, contentDescription = "Push", modifier = Modifier.size(24.dp)) },
                label = { Text("Push") },
                colors = navColors
            )
            Spacer(modifier = Modifier.height(4.dp))
            NavigationRailItem(
                selected = currentRoute is Route.Settings,
                onClick = { onNavigate(Route.Settings) },
                icon = { Icon(Icons.Default.Settings, contentDescription = "Settings", modifier = Modifier.size(24.dp)) },
                label = { Text("Settings") },
                colors = navColors
            )
        }

        NavigationRailItem(
            selected = false,
            onClick = onLogout,
            icon = { Icon(Icons.AutoMirrored.Filled.ExitToApp, contentDescription = "Logout", modifier = Modifier.size(24.dp)) },
            label = { Text("Logout") },
            colors = NavigationRailItemDefaults.colors(
                selectedIconColor = MaterialTheme.colorScheme.error,
                selectedTextColor = MaterialTheme.colorScheme.error
            )
        )
    }
}
